import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { deleteDevice as deleteDeviceService } from '../services/deleteDevice.service';

export const deleteDevice = createAsyncThunk(
  'devices/deleteDevice',
  async (deviceId, { getState, rejectWithValue }) => {
    const state = getState();

    const selectedProject = selectSelectedProject(state);
    const businessId = selectedProject?.business_id;

    if (!businessId) {
      return rejectWithValue({ message: 'no business id' });
    }

    try {
      await deleteDeviceService(businessId, deviceId);
      return deviceId;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
      });
    }
  }
);
